import React, { useContext, useRef, useState } from 'react';
import { styled } from '@mui/material/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import { Card, CardContent, MenuItem, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';

import ListItemText from '@mui/material/ListItemText';
import { Link as RouterLink } from 'react-router-dom';
import DropDownMenu from '@/components/DropDownMenu/DropDownMenu';
import Typography from '@mui/material/Typography';

const PREFIX = 'MerchsTable';

const classes = {
  root: `${PREFIX}-root`,
  content: `${PREFIX}-content`,
  inner: `${PREFIX}-inner`,
  nameContainer: `${PREFIX}-nameContainer`,
  avatar: `${PREFIX}-avatar`,
  actions: `${PREFIX}-actions`,
  fab: `${PREFIX}-fab`,
  hint: `${PREFIX}-hint`,
  photo: `${PREFIX}-photo`,
};

const StyledCard = styled(Card)(({ theme }) => ({
  [`&.${classes.root}`]: {
    overflowX: 'auto',
  },

  [`& .${classes.content}`]: {
    padding: 0,
  },

  [`& .${classes.inner}`]: {
    minWidth: 600,
  },

  [`& .${classes.nameContainer}`]: {
    display: 'flex',
    alignItems: 'center',
  },

  [`& .${classes.avatar}`]: {
    marginRight: theme.spacing(2),
  },

  [`& .${classes.actions}`]: {
    justifyContent: 'flex-end',
  },

  [`& .${classes.fab}`]: {
    margin: theme.spacing(1),
  },

  [`& .${classes.hint}`]: {
    marginLeft: 10,
    height: 16,
    width: 16,
    minHeight: 16,
  },

  [`& .${classes.photo}`]: {
    maxWidth: '70px',
    maxHeight: '70px',
    borderRadius: '7%',
  },
}));

const MerchsTable = props => {
  const { className, meetupId, merchs, handleDelete, ...rest } = props;

  if (!merchs) {
    return null;
  }

  return (
    <StyledCard {...rest} className={clsx(classes.root, className)}>
      <CardContent className={classes.content}>
        <div className={classes.inner}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Название</TableCell>
                <TableCell>Изображение</TableCell>
                <TableCell>Стоимость</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {merchs.map((merch, i) => (
                <TableRow className={classes.tableRow} hover key={merch.merchId}>
                  <TableCell>
                    <RouterLink to={'/m/' + meetupId + '/merch/id/' + merch.merchId}>
                      <Typography style={{ fontWeight: 'bold' }}>{merch.name}</Typography>
                    </RouterLink>
                  </TableCell>
                  <TableCell>
                    {merch.imageId && (
                      <img className={classes.photo} src={'/api/image/' + merch.imageId} alt={'Изображение'} />
                    )}
                  </TableCell>
                  <TableCell>
                    <Typography>{merch.price}</Typography>
                  </TableCell>

                  <TableCell style={{ textAlign: 'center', width: '100px' }}>
                    <DropDownMenu data-test-id='merch-menu'>
                      <MenuItem>
                        <RouterLink to={'/m/' + meetupId + '/merch/id/' + merch.merchId} data-test-id='merch-menu-edit'>
                          <ListItemText primary='Редактировать' />
                        </RouterLink>
                      </MenuItem>
                      <MenuItem onClick={() => handleDelete(meetupId, merch.merchId)} data-test-id='merch-menu-delete'>
                        <ListItemText primary='Удалить' />
                      </MenuItem>
                    </DropDownMenu>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </CardContent>
    </StyledCard>
  );
};

MerchsTable.propTypes = {
  className: PropTypes.string,
  merchs: PropTypes.array.isRequired,
  handleDelete: PropTypes.func,
};

export default MerchsTable;
